import { Typography } from 'antd';
import styled, { css } from 'styled-components';

const defaultFontSize = 16;

// px转换em
export function em(pxValue) {
  return pxValue / defaultFontSize + 'em';
}

export function px(pxValue) {
  return pxValue + 'px';
}

export function vw(pxValue) {
  return pxValue * 1 + 'rem';
}

// 计算适合的px
export function dynamicPx({ minSize, maxSize, maxVW = 1920, minVW = 375 }) {
  return `clamp(${px(
    minSize
  )}, calc(${minSize}px + (${maxSize} - ${minSize}) * ((100vw - ${minVW}px) / (${maxVW} - ${minVW}))), ${px(
    maxSize
  )}) `;
}

export const flexStyle = css`
  display: flex;
`;

export const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

export const center = css`
  display: grid;
  place-items: center;
`;

export const propsCss = css`
  --dynamic-px: ${(props) =>
    props.$maxSize &&
    props.$minSize &&
    dynamicPx({ minSize: props.$minSize, maxSize: props.$maxSize })};

  font-family: inherit;
  color: ${(props) => props.$color && `${props.$color} !important`};
  font-size: ${(props) =>
    props.$maxSize && props.$minSize
      ? 'var(--dynamic-px)'
      : props.fontSize
      ? props.fontSize
      : `var(--step-${props.step || 0})`} !important;

  ${(props) => (props.fontWeight ? `font-weight:${props.fontWeight} !important` : undefined)};
`;

export const TitleTypography = styled(Typography.Title)`
  ${propsCss}
  margin: 0 !important;
`;

export const TextTypography = styled(Typography.Text)`
  ${propsCss}
`;

export const Separator = styled.hr`
  margin: 1em 0;
`;

export const ellipsisCss = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const lineClamp = css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => (props.$line ? `${props.$line}` : 3)};
  -webkit-box-orient: vertical;
`;
